var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconExploreActive = function SvgIconExploreActive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 30 30"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_explore_active_svg__a)",
    d: "M25.766 16.511a10.86 10.86 0 0 1-5.329 7.886 10.86 10.86 0 0 1-9.494.672c2.445-.826 5.129-2.05 7.806-3.596 2.677-1.545 5.08-3.257 7.017-4.962"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_explore_active_svg__b)",
    d: "M25.87 5.452c1.231.077 2.519.467 3.169 1.593.586 1.016.391 2.184-.043 3.19-.444 1.03-1.232 2.126-2.237 3.223-2.02 2.203-5.102 4.603-8.76 6.715s-7.279 3.582-10.197 4.23c-1.452.322-2.795.456-3.909.325-1.088-.127-2.197-.542-2.784-1.558-.65-1.126-.344-2.436.205-3.54a1.126 1.126 0 0 1 2.014 1.003c-.44.884-.345 1.283-.27 1.412.066.115.306.356 1.097.449.766.09 1.834.006 3.16-.288 2.639-.586 6.043-1.95 9.559-3.98s6.4-4.297 8.226-6.289c.918-1 1.525-1.884 1.83-2.592.315-.732.226-1.06.16-1.175-.075-.129-.372-.41-1.358-.472a1.125 1.125 0 0 1 .139-2.246"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_explore_active_svg__c)",
    fillRule: "evenodd",
    d: "M9.562 5.56c5.202-3.003 11.853-1.22 14.856 3.98q.154.27.292.542-.302.39-.715.842c-1.697 1.852-4.45 4.027-7.871 6.003-3.42 1.974-6.681 3.27-9.133 3.815q-.599.131-1.087.198-.168-.256-.323-.524C2.58 15.214 4.361 8.563 9.562 5.56m7.725.723a.444.444 0 0 0-.825 0l-.552 1.389a2.67 2.67 0 0 1-1.492 1.492l-1.389.551a.444.444 0 0 0 0 .826l1.39.551c.68.27 1.22.811 1.491 1.493l.552 1.388a.444.444 0 0 0 .825 0l.552-1.388c.27-.682.81-1.222 1.492-1.493l1.388-.551a.444.444 0 0 0 0-.826l-1.388-.55a2.67 2.67 0 0 1-1.492-1.493z",
    clipRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_explore_active_svg__a",
    x1: 0.742,
    x2: 29.405,
    y1: 14.978,
    y2: 14.978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#4FD8F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF82FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_explore_active_svg__b",
    x1: 0.742,
    x2: 29.405,
    y1: 14.978,
    y2: 14.978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#4FD8F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF82FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_explore_active_svg__c",
    x1: 0.742,
    x2: 29.405,
    y1: 14.978,
    y2: 14.978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#4FD8F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF82FB"
  })))));
};
export default SvgIconExploreActive;